import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFiltersClear = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .7,
			width: 18,
			height: 18,
			rx: 5,
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6L6 12",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12L6 6",
			stroke: "white"
		})
	]
});
export default SvgFiltersClear;
